export default __webpack_public_path__ + "static/shopping@2x-bb072d64f79bdcbf43cb3a205ba9402f.png";